import React from "react";
import { PaymentOperationTypeDisplay } from "../../../../../store/AuditTrail/Displays";
import { Payment } from "../../../../../store/AuditTrail/PaymentTypes";
import { CreditDebitIndicatorTypeDisplay } from "../../../../../store/Statements/Displays";
import { CreditDebitIndicator } from "../../../../../store/Statements/Types";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface OwnProps {
    details: Payment;
}

type Props = OwnProps;

/**
 *
 */
export class Detail
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);

    }

    public render() {
        return (
            <>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Number}
                            label="Payment id"
                            asSummary
                            value={this.props.details.id}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Number}
                            label="Invoice number"
                            asSummary
                            value={this.props.details.invoiceNumber}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            label="Invoice date"
                            asSummary
                            value={this.props.details.invoiceDate}
                            type={FieldTypes.Date}
                        />
                    </Grid>
                </Div>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            label="Mutation type"
                            asSummary
                            value={this.props.details.creditDebitIndicator === CreditDebitIndicator.DBIT
                                ? CreditDebitIndicatorTypeDisplay.DBIT : CreditDebitIndicatorTypeDisplay.CRDT}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            label="Operation"
                            asSummary
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            value={PaymentOperationTypeDisplay[this.props.details?.operation ?? ""]}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            value={this.props.details.amount}
                            label="Amount"
                            asSummary
                            type={FieldTypes.CurrencyDisplay}
                        />
                    </Grid>
                </Div>
            </>
        );
    }
}
